import React from "react";
import "./Frame82.css";

function Frame82(props) {
  const { children } = props;

  return (
    <div className="frame-8-11">
      <div className="x4-identification-des-contre-mesures">{children}</div>
    </div>
  );
}

export default Frame82;
